<template>
  <div class="erweima">
    <p class="bg">
      <img :src="this.qrCode" alt="" class="qrCode">
    </p>
  </div>
</template>

<script>
export default {
    data(){
        return{
            orderData:"",  //接收酷屏通过URL传过来的数据
            qrCode: '',
            extcustomerid: '',
            extuserid: ''
        }
    },
    methods: {
        payOrderQuery(val){
            let reqHead = {
                orderNo:val,
                TransId:"QueryIpayOrder",
            }
            let reqBody = {}
            let params = {
                extcountrycode:'HKG',
                extcustomerid:'500703',
                extcustomername:'CTCB',
                extuserid:'AP2AP001',
                extcaid:'IVR',
                extsessionid:'NAHKBUPBBKHXOBNYEK',
                extidlang:'tch',
                channelId:'EWEC'
            }
            // console.log(params)
             this.$api.post("/creatQrCode.do",params).then(res => {
               console.log(res)
               this.extuserid = res.extuserid
               this.extcustomerid = res.extcustomerid
               this.qrCode = 'data:image/png;base64,' + res.qrValue
               this.queryVCodeState(res.qrCode)
            })
            // this.$api.post("/sxyh",params).then(res => {
            //     if(res.ResHead.SysRtnCd == "00000000"){
            //         this.$store.state.payInfo = res.ResBody.OrderEntity,
            //         this.$store.state.smsType = res.ResBody.SmsType,
            //         this.$store.state.successUrl = res.ResBody.DetailUrl,
            //         this.$store.state.accList =  res.ResBody.AccList,
            //         this.$store.state.orderNo = res.ResBody.OrderNo
            //         //1 未签约  0 已签约
            //         if(res.ResBody.PaySignType == "0"){
            //             this.$router.replace("/pay")
            //         }else{
            //             this.$router.replace("/sign")
            //         }
            //     }else{
            //         this.$dialog.alert({
            //             title:"温馨提示",
            //             content:res.ResHead.SysRtnDesc
            //         })
            //     }
            // })
        },
        // 查看二维码状态
        queryVCodeState(qrValue) {
          this.loginTimer = window.setInterval(() => {
            let params = {
              qrCode:qrValue,
              extcustomerid:this.extcustomerid,
              extuserid:this.extuserid
            }
            this.$api.post("/qryQrCode.do",params).then(res => {
              console.log(res)
                // 'qrState' 二维码状态说明 0-未处理， 1-处理成功， 2，已失效
                if (res.qrcodestate== '0') {
                      // 0-未处理 没有扫码，不做业务处理
                } else if (res.qrcodestate == '1') {
                      // 1-处理成功
                      this.$router.replace("/login")
                      window.clearInterval(this.loginTimer)
                } else if(res.qrcodestate == '2') {
                  // 2.已失效 登陆失败重新生成二维码
                  window.clearInterval(this.loginTimer)
                }
            })
          },3000)
        },
        updQrCodeState() {
          this.$api.post("/updQrCodeState.do",params).then(res => {
              console.log(res)
        })
      }
    },
    created () {
        this.orderData = this.$route.query.data;
        // this.queryVCodeState(res.qrValue)
        this.payOrderQuery(this.orderData);
        // this.updQrCodeState()
    },
}
</script>

<style>
.erweima{
  width: 100%;
  height: 450px;
  background: #fff;

}
.bg{
  height: 450px;
  width: 684px;
  margin: 0px auto;
  position: relative;
  background:url(./image/erweima.png) no-repeat center 34px/684px 382px;
}
.qrCode{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
</style>



// WEBPACK FOOTER //
// src/views/empty/empty.vue